export default "__VITE_ASSET__f4991148__"